import {
  CATEGORIES_FETCH_SUCCESS_ECOMMERCE,
  CATEGORY_LOADING,
  CATEGORY_CREATE_DRAFT,
  SELECTED_CATEGORY,
  CATEGORY_FETCH_SUCCESS,
  CATEGORY_EDIT_DRAFT
} from '../constant/actionType';

const initialState = {
  categories: [],
  categoryCreateDraft: {},
  isLoaded: false,
  selectedCategory: {},
  selectedCategoryDraft: {},
  selectedCategoryEdit: {}
};

const categoriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case CATEGORIES_FETCH_SUCCESS_ECOMMERCE:
      return {
        ...state,
        categories: action.data,
        isLoaded: true
      };
    case SELECTED_CATEGORY:
      return {
        ...state,
        categoryCreateDraft: action.data,
        selectedCategory: action.data
      };
    case CATEGORY_CREATE_DRAFT:
      return {
        ...state,
        categoryCreateDraft: { ...state.categoryCreateDraft, ...action.data }
      };
    case CATEGORY_FETCH_SUCCESS:
      return {
        ...state,
        isLoaded: true,
        selectedCategoryDraft: action.data,
        selectedCategoryEdit: action.data
      };
    case CATEGORY_EDIT_DRAFT:
      return {
        ...state,
        selectedCategoryDraft: { ...action.data }
      };
    case CATEGORY_LOADING:
      return {
        ...state,
        isLoaded: false
      };
    default:
      return state;
  }
};

export default categoriesReducer;
